var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 14 14"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","d":"M5.654 0a5.654 5.654 0 1 0 3.599 10.014l3.828 3.828a.538.538 0 1 0 .76-.761l-3.827-3.829A5.654 5.654 0 0 0 5.654 0M1.077 5.654a4.577 4.577 0 1 1 9.153 0 4.577 4.577 0 0 1-9.153 0"}})])
}
var staticRenderFns = []

export default { render: render }